import React, { useState } from 'react';
import { Box, Typography, TextField, TextFieldProps, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

export interface InputFieldProps extends Omit<TextFieldProps, 'onChange'> {
  label: string;
  labelSuffix?: string;
  name: string;
  value: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  error?: boolean;
  helperText?: string | false | undefined;
  required?: boolean;
  inputPlaceholder?: string;
  disabled?: boolean;
  type?: string;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  labelSuffix = ":",
  name,
  value,
  onChange,
  onBlur,
  error,
  helperText,
  required = false,
  inputPlaceholder,
  disabled,
  type,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <Box>
      <Typography 
        variant="body2" 
        sx={{ 
          mb: 1, 
          fontWeight: 500, 
          color: "#333",
          display: 'flex',
          alignItems: 'center',
          '&::after': {
            content: required ? '"\u00a0*"' : `"\u00a0${labelSuffix}"`,
            color: required ? 'error.main' : '#333',
            ml: 0.5,
            fontSize: '1rem'
          }
        }}
      >
        {label}
      </Typography>
      <TextField
        fullWidth
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        required={required}
        disabled={disabled}
        type={type === 'password' ? (showPassword ? 'text' : 'password') : type}
        variant="outlined"
        error={error}
        helperText={helperText}
        placeholder={inputPlaceholder || `กรุณาระบุ${label}`}
        InputProps={{
          endAdornment: type === 'password' ? (
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ) : null,
        }}
        {...props}
      />
    </Box>
  );
};

export default InputField; 